import { inject } from '@angular/core';
import { PS_CATCH_ERROR } from '@ps/utils';

export class EffectsBase {
  protected readonly psCatchError = inject(PS_CATCH_ERROR);
}
